var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo",attrs:{"to":{ name: 'homepage' }}},[_c('img',{attrs:{"src":require("../assets/img/logo-s.webp"),"width":"207","height":"79"}})])}
var staticRenderFns = []

export { render, staticRenderFns }